export default {
  app: {
    tradeOffers: {
      country: '國家',
      loginPrompt: '欲查看私人交易情形，您需要{0}.',
      logIn: '登入',
    },
  },
};
